<template>
  <DiscountPassVerification
    :validation-params="validationParams"
    :show-form-level-error-message="true"
    default-error-message="Invalid passcode and/or email entered. Please try again."
    :after-success="afterSuccess"
    v-on="$listeners"
  >
    <div slot="summary" class="info">
      <h2 class="legend">Verify Eligibility</h2>
    </div>
    <template slot="eligibility-fields">
      <Email v-model="validationParams.email" />
      <Input
        id="passcode"
        v-model="validationParams.validationString"
        label="Discount Validation Passcode"
        name="passcode"
        autocapitalize="off"
        autocorrect="off"
        required
      />
    </template>
  </DiscountPassVerification>
</template>

<script>
import Email from '@/components/Email.vue';
import DiscountPassVerification from './DiscountPassVerification.vue';
import Input from '../Input.vue';

export default {
  components: { Email, DiscountPassVerification, Input },
  data() {
    return {
      validationParams: {
        validationType: 'passcode',
        email: '',
        validationString: '',
      },
    };
  },
  mounted() {
    if (this.$store.state.registration.enrollmentCode) {
      this.validationParams.validationString = this.$store.state.registration.enrollmentCode;
    }
  },
  methods: {
    afterSuccess() {
      // After successful validation, before navigating to the next step
      this.$store.dispatch('updateUser', {
        email: this.validationParams.email,
      });
    },
  },
};
</script>
